import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Text } from 'components/common';
import SettingsButton from 'components/Pages/Settings/common/SettingsButton';
import SettingsInputContainer from 'components/Pages/Settings/common/SettingsInputContainer';
import replaceSettingsMsg from 'utils/replace-settings-msg';

const UpdatePage = ({
  Component,
  title,
  user,
  isRiskLocked,
  close,
  next,
  summary,
  accessor,
}) => (
  <>
    <Text size="text-xl" className="text-center">
      {title}
    </Text>
    {summary && (
      <div className="mt-2 text-sm text-center">
        {replaceSettingsMsg(summary, accessor, user, { isRiskLocked }).map(
          ({ text, isBold }) => (
            <p
              key={title}
              className={classnames("mr-1 inline", { "font-bold": isBold })}
            >
              {text}
            </p>
          )
        )}
      </div>
    )}

    <Component
      user={user}
      isRiskLocked={isRiskLocked}
      SettingsButton={SettingsButton((res) => {
        if (res.success) {
          next();
        }
      })}
      next={next}
      SettingsInputContainer={SettingsInputContainer}
    />
    {/* <div className="fixed w-full left-0 text-center" style={{ bottom: 120 }}>
      <div className="text-gray-primary" onClick={close}>
        Back
      </div>
    </div> */}
  </>
);

export default UpdatePage;
